module.exports = __webpack_public_path__ + "img/member3.ed6acd95.png";